export const PPO_ADMIN_COMMENTS = {
  TITLE: 'Admin Comments',
};
